<script lang="ts" setup>
import { MobileFiltersBarMagazineProps } from "~/components/Filters/Utils/MobileFiltersBarMagazine.props"

withDefaults(defineProps<MobileFiltersBarMagazineProps>(), {
  sortingOpen: false,
  bg: true
})

const emit = defineEmits<{ (e: "onSearch"): void }>()
</script>

<template>
  <div class="mobile-filters-bar-magazine">
    <div
      class="mobile-filters-bar__controls flex"
      :class="{ 'border-black-10 bg-tiffany-10 border-y py-2': bg }"
    >
      <button
        class="mobile-filters-bar-magazine__btn beaver-bold"
        @click="emit('onSearch')"
      >
        <UtilsIcon name="Options.svg" class="h-5 w-5" />
        {{ $t("filters.utils.mobileFiltersBar.categories") }}
        <UtilsIcon
          name="ChevronDown.svg"
          class="h-5 w-5 transition-transform duration-300"
          :class="{ 'rotate-x-180': sortingOpen }"
        />
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.mobile-filters-bar-magazine {
  &__btn {
    @apply flex flex-1 items-center justify-center px-4 py-1 uppercase;
  }
}

</style>
